<template>
  <v-dialog v-model="model" v-bind="$attrs" v-on="$listeners">
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" v-bind="{ on, attrs }"></slot>
    </template>
    <v-card :loading="loading">
      <slot name="title">
        <v-card-title>{{ title }}</v-card-title>
      </slot>
      <slot></slot>
      <slot name="actions">
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <tcn-au-btn @click="closeDialog">
            {{ closeText ? closeText : $t("cancelDefault") }}
          </tcn-au-btn
          >
          <tcn-au-btn
              v-if="!!acceptText"
              :disabled="acceptDisabled"
              rounded
              small
              :color="acceptColor ? acceptColor : 'success'"
              @click="acceptDialog"
          >{{ acceptText }}
          </tcn-au-btn
          >
        </v-card-actions>
      </slot>
    </v-card>
  </v-dialog>
</template>

<script>
import TcnAuBtn from '../TecnaAureaBtn/TcnAuBtn.vue';

// eslint-disable-next-line no-unused-vars
// const messages = {
//         "en": {
//           "cancelDefault": "Cancel"
//         },
//         "pl": {
//           "cancelDefault": "Anuluj"
//         }
//       }
export default {
  components: { TcnAuBtn },
  name: "TcnAuDialog",
  props: [
    "value",
    "title",
    "acceptText",
    "acceptColor",
    "acceptDisabled",
    "closeText",
    "loading"
  ],
  data() {
    return {
    }
  },
  methods: {
    closeDialog() {
      this.model = false
      this.$emit("closeButton");
    },
    acceptDialog() {
      this.$emit("acceptButton");
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
};
</script>
<!-- lang="i18n" WAŻNE !!! -->
<i18n lang="i18n">
{
  "en": {
    "cancelDefault": "Cancel"
  },
  "pl": {
    "cancelDefault": "Anuluj"
  }
}

</i18n>
<style></style>
